// extracted by mini-css-extract-plugin
export default {"loaded":"loaded-nZOZ"};